/** Letters and digits only, so "green button" matches "Greenbutton Data". */
const searchText = (value: string): string =>
  value.toLowerCase().replace(/[^a-z0-9]/g, ``)

/** The palette's entries whose label contains the query, ignoring case,
 * spaces and punctuation. An empty query keeps every entry. */
export const matchProposalSetupSearch = <
  Entry extends { readonly label: string },
>(
  query: string,
  entries: readonly Entry[],
): readonly Entry[] => {
  const needle = searchText(query)
  if (needle === ``) {
    return entries
  }

  return entries.filter((entry) => searchText(entry.label).includes(needle))
}
